// KakaoPayApprovalPage.tsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useAppSelector } from '@/redux/store';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';

const KakaoPayApprovalPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mutate: approveKakaoPay } = usePost(CPLAT_API_ROUTES.setSubscriptionForKakaopay);
  const { CplatToken, UserNo } = useAppSelector((state) => state.user);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pgToken = params.get('pg_token');
    const kakaoPayRequestInfo = JSON.parse(localStorage.getItem('kakaoPayRequestInfo') || '{}');
    const kakaoPayResponseInfo = JSON.parse(localStorage.getItem('kakaoPayResponseInfo') || '{}');
    // const subscriptionNo = kakaoPayRequestInfo?.SubscriptionNo || 21; // 실제로 저장한 값에 따라 조정
    const subscriptionNo = Number(localStorage.getItem('subscriptionNo'));

    if (pgToken) {
      approveKakaoPay(
        {
          cplatToken: CplatToken,
          subscriptionNo,
          pgToken,
          kakaoPayRequestInfo,
          kakaoPayResponseInfo,
        },
        {
          onSuccess: () => {
            // 결제 성공 안내 및 구독정보 갱신
            navigate('/more/membership?result=success');
          },
          onError: () => {
            navigate('/more/membership?result=fail');
          },
        },
      );
    }
  }, [approveKakaoPay, location, navigate]);

  return <GlobalSpinner />;
};

export default KakaoPayApprovalPage;
